import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateMainDealer } from "@/api/mainDealers";
import { MainDealersQueryKeys } from "@/tanstackQuery/queries";

export const useUpdateMainDealer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMainDealer,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [MainDealersQueryKeys.All],
      });
    },
  });
};
